import { MetaGamesEventType } from '../../dto/metagames.types';

export const METAGAMES_EVENT_TYPES: readonly string[] = Object.values(MetaGamesEventType);
